export var QuestionnaireFlow;
(function (QuestionnaireFlow) {
    QuestionnaireFlow["APIError"] = "API Error";
    QuestionnaireFlow["BusinessError"] = "Business Error";
    QuestionnaireFlow["CancelDispute"] = "Cancel Dispute";
    QuestionnaireFlow["CancelQuestionnaire"] = "Cancel Questionnaire";
    QuestionnaireFlow["CantIdentifyDup"] = "Cannot Identify Dup";
    QuestionnaireFlow["ContactFraud"] = "Contact Fraud";
    QuestionnaireFlow["CreditDetails"] = "Credit Details";
    QuestionnaireFlow["End"] = "End";
    QuestionnaireFlow["Exit"] = "Exit";
    QuestionnaireFlow["InProgress"] = "In Progress";
    QuestionnaireFlow["RecognizeCharge"] = "Recognize Charge";
    QuestionnaireFlow["RedisputeNotEligible"] = "Redispute Not Eligible";
    QuestionnaireFlow["Review"] = "Review";
    QuestionnaireFlow["RedisputeReview"] = "Redispute Review";
    QuestionnaireFlow["Start"] = "Start";
})(QuestionnaireFlow || (QuestionnaireFlow = {}));
export var TransactionsStatus;
(function (TransactionsStatus) {
    TransactionsStatus[TransactionsStatus["Success"] = 200] = "Success";
    TransactionsStatus[TransactionsStatus["MultiStatus"] = 207] = "MultiStatus";
    TransactionsStatus[TransactionsStatus["BadRequest"] = 400] = "BadRequest";
    TransactionsStatus[TransactionsStatus["Unauthorized"] = 401] = "Unauthorized";
    TransactionsStatus[TransactionsStatus["Forbidden"] = 403] = "Forbidden";
    TransactionsStatus[TransactionsStatus["NotFound"] = 404] = "NotFound";
    TransactionsStatus[TransactionsStatus["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    TransactionsStatus[TransactionsStatus["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    TransactionsStatus[TransactionsStatus["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    TransactionsStatus[TransactionsStatus["InternalServerError"] = 500] = "InternalServerError";
    TransactionsStatus[TransactionsStatus["BadGateway"] = 502] = "BadGateway";
    TransactionsStatus[TransactionsStatus["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    TransactionsStatus[TransactionsStatus["GatewayTimeout"] = 504] = "GatewayTimeout";
})(TransactionsStatus || (TransactionsStatus = {}));
export var FieldType;
(function (FieldType) {
    FieldType["Chips"] = "CHIPS";
    FieldType["Date"] = "DATE";
    FieldType["DropDown"] = "DROPDOWN";
    FieldType["TextArea"] = "TEXTAREA";
    FieldType["TextBox"] = "TEXTBOX";
    FieldType["PopUp"] = "POPUP";
    FieldType["Radio"] = "RADIOBUTTON";
    FieldType["Text"] = "TEXT";
    FieldType["TableList"] = "TABLE_LIST";
})(FieldType || (FieldType = {}));
export var ErrorSource;
(function (ErrorSource) {
    ErrorSource["Questionnaire"] = "Questionnaire";
    ErrorSource["PostCases"] = "Post Cases";
    ErrorSource["Authentication"] = "Authentication";
})(ErrorSource || (ErrorSource = {}));
//# sourceMappingURL=typings.js.map